module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/145-ukraine-e71c2e79054d8b6eb626644a11a1989d.svg";